<template>
  <div>
    <div>
      <client-note-creator
        v-bind:client-id="clientId"
        v-on:showAlert="showAlert"
        v-on:refresh="forwardEvent"
      >
      </client-note-creator>
    </div>
    <div v-if="notes" class="mt-3">
      <div v-for="note in notes" :key="note.id">
        <b-alert :variant="note.category" show class="row mx-auto">
          <b-col sm="auto" xl="10">
            <p>{{ note.created_at | moment }}</p>
            <p>{{ note.text }}</p>
          </b-col>
          <b-col sm="auto" xl="1">
            <b-icon
              icon="pencil"
              class="me-2"
              @click="patchNote(note)"
            ></b-icon>
            <b-icon
              icon="x-circle"
              class="me-2 mt-3"
              @click="deleteNote(note.id)"
            ></b-icon>
          </b-col>
        </b-alert>
      </div>
    </div>
    <div v-else>
      <p class="h5 mt-4">Нотаток ще немає :(</p>
    </div>
    <note-patcher v-bind:note="chosenNote" v-if="chosenNote"></note-patcher>
  </div>
</template>

<script>
import moment from "moment";
import ClientNoteCreator from "@/components/ClientPage/modals/ClientNoteCreator";
import NotePatcher from "@/components/modals/NotePatcher";

export default {
  name: "ClientNotes",
  components: {
    ClientNoteCreator,
    NotePatcher,
  },
  data() {
    return {
      chosenNote: null,
    };
  },
  props: {
    notes: Array,
    clientId: Number,
  },
  methods: {
    forwardEvent() {
      this.$emit("refresh");
    },
    showAlert(text, color) {
      this.$emit("showAlert", text, color);
    },
    patchNote(note) {
      this.chosenNote = note;
      this.$root.$emit("bv::show::modal", "modal-note-patcher");
    },
    async deleteNote(noteId) {
      let result = confirm("Ви впевнені що хочете видалити нотатку?");
      if (!result) return;
      this.$api.clients
        .deleteNote(noteId)
        .then(() => {
          this.showAlert("Нотатко успішно видалена!", "green");
          this.forwardEvent();
        })
        .catch((err) => {
          if (err.response) {
            this.showAlert("Щось пішло не так...", "red");
          }
        });
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD-MM-YYYY");
    },
  },
};
</script>

<style scoped></style>
